const GA = {
  serviceFilter: (service) => {
    if (window.gtag){
        gtag('event', 'filter_service', {
            'event_label' : 'Filter service',
            'service' : service,
        });
    }
  }
};
export default GA;